<template>
  <div class="flavor-wrap content">
    <div class="card">
      <span class="">Product Gallery</span>
      <div class="grid grid-cols-3 gap-3 mt-3">
        <ProductItem
            show-name
            v-for="(item,index) in myProducts"
            :key="item.id"
            :selected="item.selected"
            :product-info="item"
            @onSelectProduct="onSelectProduct(item,index)"/>
      </div>
    </div>

    <div class="card">
      <span class="">Flavors</span>
      <div class="mt-3 flavor-item-wrap">
        <FlavorItem
            show-name
            v-for="(item,index) in flavors"
            :key="item.id"
            :is-add="item.isAdd"
            :selected="item.selected"
            :flavor="item"
            @onEditFlavor="onEditFlavor"
            @onAddFlavor="onAddFlavor"
            @onSelectFlavor="onSelectFlavor(item,index)"/>
      </div>
    </div>


    <PopupFlavorWrite v-if="currenProductSelected != -1" v-model="showFlavorWrite"
        :product-info="myProducts[currenProductSelected]"
        @onWrite="onWriteNfc"
        @onCancel="onCancel"
        show-button
        :cancel-text="cancelText"
        :func-type="funcType"
        :tags="selectedFlavor.labelList"/>
    <PopupFlavorWriteResult
        v-if="currenProductSelected != -1"
        v-model="showFlavorWriteResult"
        :tag-id="currentTagId"
        :product-info="myProducts[currenProductSelected]"
        @onWrite="onWriteNfc"
        show-button
        @onContinue="onWriteNfc"
        @onComplete="onComplete"
        :counter="tagCounter.length"
        :tags="selectedFlavor.labelList"/>

    <CustomizationBottomOperateQrNfc
        :disabled="disableEdit"
        :text="createText"
        :func-type="funcType"
        @onFuncTypeChange="onFuncTypeChange"
        @onBrandEdit="onBrandEdit"
        @onNext="onNext"/>

    <NFCPopup v-model="showNfcPopup" :msg="androidPopupMsg"/>
    <DialogTips v-model="showDialogTips" title="Tips" :message="dialogTipsMessage" @onRightClick="showDialogTips = false"  :show-left="false" right-text="Confirm"/>
  </div>

</template>

<script>
import produce from "@/api/produce";
import CustomizationBottomOperate from "@/components/customization/CustomizationBottomOperate.vue";
import log from "@/util/log";
import bus from "@/util/EventBus";
import PopupBrandInfo from "@/components/customization/PopupBrandInfo.vue";
import ProductItem from "@/components/customization/ProductItem.vue";
import BrandItem from "@/components/customization/BrandItem.vue";
import FlavorItem from "@/components/FlavorItem.vue";
import CustomizationBottomOperateQrNfc from "@/components/customization/CustomizationBottomOperateQrNfc.vue";
import PopupFlavorWrite from "@/components/customization/PopupFlavorWrite.vue";
import { calcMaxPower, calcPower, calcVoltageFloorInt, convertTagId, isAndroid } from "@/util/utils";
import PopupFlavorWriteResult from "@/components/customization/PopupFlavorWriteResult.vue";
import NFCPopup from "@/components/nfc/NFCPopup.vue";
import DialogTips from "@/components/DialogTips.vue";

export default {
  name: "Flavor",
  components: {
    DialogTips,
    NFCPopup,
    PopupFlavorWriteResult,
    PopupFlavorWrite,
    CustomizationBottomOperateQrNfc,
    FlavorItem,
    BrandItem,
    ProductItem,
    PopupBrandInfo,
    CustomizationBottomOperate
  },
  props: {},
  data() {
    return {
      funcType: 2,
      myProducts: null,
      flavors: null,
      currenProductSelected: -1,
      currenFlavorSelected: -1,
      showBrandPopup: false,
      isAddBrand: false,
      submitText: "Submit",
      showFlavorWrite: false,
      showFlavorWriteResult: false,
      //nfc
      showNfcPopup: false,
      disabledNfcButton: false,
      androidPopupMsg: {
        title: "Ready to Read",
        message: "Place your product in the NFC area"
      },
      currentTagId: "",

      tagCounter: [],
      qrcodeCounter: [],

      currentFlavorId: 0,
      showDialogTips:false,
      dialogTipsMessage:'',
    };
  },
  methods: {
    async loadData() {

      const myProducts = await produce.myProducts();
      const currentProductSelected = myProducts.findIndex(item => item.id == (localStorage.getItem('selectProductId') || this.$route.query.productId));
      if (currentProductSelected === -1) {
        this.$router.back();
        return;
      }
      log(`product id = ${this.$route.query.productId} index = ${currentProductSelected}`);
      this.currenProductSelected = currentProductSelected;

      myProducts.forEach((item, index) => {
        item.selected = currentProductSelected === index;
      });
      this.myProducts = myProducts;
      await this.queryFlavor(this.$route.query.brandId, myProducts[currentProductSelected].id);
    },

    async queryFlavor(brandId, deviceId, showLoading = false) {
      const flavors = await produce.flavors({ brandId, deviceId }, showLoading);
      flavors.forEach(item => {
        item.selected = false;
      });
      flavors.push({
        id: 0,
        isAdd: true
      });
      this.flavors = flavors;
    },

    async onSelectProduct(item, index) {
      const myProducts = this.myProducts;
      if (this.currenProductSelected !== -1) {
        myProducts[this.currenProductSelected].selected = false;
      }
      myProducts[index].selected = true;
      this.currenProductSelected = index;
      await this.queryFlavor(this.$route.query.brandId, myProducts[index].id, true);
    },
    onAddFlavor() {
      log(`添加口味点击`);
      if (this.currenFlavorSelected !== -1) {
        this.flavors[this.currenFlavorSelected].selected = false;
      }
      this.currenFlavorSelected = -1;
      const product = this.myProducts[this.currenProductSelected];
      localStorage.setItem("selectProductId", product.id);
      console.log(`product id = `, this.$route.query.productId);
      this.$router.push({
        path: "/set-flavor",
        query: {
          brandId: this.$route.query.brandId,
          productId: product.id
        }
      });
    },
    onEditFlavor(flavor) {

      const id = flavor.id;
      this.currenFlavorSelected = -1;
      const product = this.myProducts[this.currenProductSelected];
      localStorage.setItem("selectProductId", product.id);
      this.$router.push({
        path: "/set-flavor",
        query: {
          brandId: this.$route.query.brandId,
          productId: product.id,
          id
        }
      });
    },
    async onSelectFlavor(item, index) {
      const flavors = this.flavors;
      if (this.currenFlavorSelected !== -1) {
        flavors[this.currenFlavorSelected].selected = false;
      }
      flavors[index].selected = true;

      this.currenFlavorSelected = index;
    },
    onAddBrand() {
      if (this.currenProductSelected !== -1) {
        this.myBrands[this.currenProductSelected].selected = false;
      }
      this.currenProductSelected = -1;
      this.submitText = "Apply";
      this.isAddBrand = true;
      this.showBrandPopup = true;
    },
    onBrandEdit() {
      this.isAddBrand = false;
      log("onBrandEdit");
      this.submitText = "Submit";
      this.showBrandPopup = true;
    },
    onFuncTypeChange(funcType) {
      this.funcType = funcType;
    },
    onNext() {
      log("onNext");
      this.showFlavorWrite = true;
    },
    onUpdateBrandInfo(brandInfo) {
      const index = this.myBrands.findIndex(item => item.id === brandInfo.id);
      if (index === -1) {
        return;
      }

      log(`Update brand info ${JSON.stringify(brandInfo)}`);
      this.myBrands[index] = brandInfo;
    },

    //nfc
    getNFCReader(isRead = true) {
      if (this.disabledNfcButton) {
        return null;
      }
      const nfcReader = navigator.nfcReader;
      if (!nfcReader) {
        return null;
      }

      if (!this.isInitErrorHandler) {
        nfcReader.addEventListener(
            "receiveInvalidateWithError",
            this.handlerNFCError
        );
        this.isInitErrorHandler = true;
      }

      if (!this.isInitBegingEvent) {
        nfcReader.addEventListener(
            "receiveBegingActive",
            this.handleBeingActive
        );
        this.isInitBegingEvent = true;
      }

      if (isRead) {
        this.androidPopupMsg = {
          title: "Ready to Read",
          message: "Place your product in the NFC area"
        };
      } else {
        this.androidPopupMsg = {
          title: "Ready to Write",
          message: "Place your product in the NFC area"
        };
      }

      this.showNfcPopup = isAndroid();
      if (!this.showNfcPopup) {
        this.disabledNfcButton = true;
      }
      return nfcReader;
    },

    handlerNFCError(event) {
      log("出现错误 " + JSON.stringify(event.error));
      if (event.error.errorCode !== 200) {
        // navigator.nfcReader.endReaderSession(false, "");
      }
      log(`disabledNfcButton before = ${this.disabledNfcButton}`);
      this.disabledNfcButton = false;
      log(`disabledNfcButton after= ${this.disabledNfcButton}`);
    },
    handleBeingActive(event) {
      log("handleBeingActive ");
      // this.toastObj.clear();
    },

    async onWriteNfc() {
      if (this.funcType === 1) {
        await this.scanQrCode();
      } else if (this.funcType === 2) {
        await this.writeNfc();
      }
    },
    onCancel() {
      if (this.tagCounter.length > 0 || this.qrcodeCounter.length > 0) {
        this.onComplete();
      } else {
        this.showFlavorWrite = false;
      }
    },
    async scanQrCode() {
      if (!navigator.qrcode) {
        this.dialogTipsMessage = "Please use OMNI app,current environment is not supported"
        this.showDialogTips = true
        return;
      }
      let result = await navigator.qrcode.scanQRCode();
      log(`二维码扫描结果 = ${result}`);
      let index = this.qrcodeCounter.findIndex(item => (item.code === result));
      if (index !== -1) {
        this.dialogTipsMessage = "Repeated scans code"
        this.showDialogTips = true
        return;
      }

      const resp = await produce.scanBrandQrcode({ code: result });
      const { data, code, message } = resp;
      if (code !== 200) {
        this.dialogTipsMessage = message
        this.showDialogTips = true
        return;
      }
      index = this.qrcodeCounter.findIndex(item => (item.deviceTypeId !== data.deviceTypeId));
      if (index !== -1) {
        this.dialogTipsMessage = "Inconsistent device types"
        this.showDialogTips = true
        return;
      }
      this.qrcodeCounter.push(data);
    },

    async writeNfc() {
      if (this.disabledNfcButton) {
        return;
      }
      this.showFlavorWriteResult = false;
      //
      // this.showFlavorWriteResult = true
      // return

      const nfcReader = this.getNFCReader(false);
      if (!nfcReader) {
        return;
      }


      const session = await nfcReader.beginReaderSession(2, {
        operate: 2,
        alertMessage: "Place your product in the NFC area."
      });
      log(`tag id = ${session.id}`);
      let tagId;
      try {

        await session.connect();
        tagId = convertTagId(session.id);

        nfcReader.endReaderSession(true, "Read Success!");
        if (this.tagCounter.indexOf(tagId) !== -1) {
          this.dialogTipsMessage = "Duplicate Device"
          this.showDialogTips = true
          return;
        }
        try {
          const flavorId = this.flavors[this.currenFlavorSelected].id;

          if (this.currentFlavorId === 0) {
            this.currentFlavorId = flavorId;
          } else if (this.currentFlavorId !== flavorId) {
            //这次设置的口味与上一次不一样了，上传数据并清空计数
            const brandId = this.$route.query.brandId;
            try {
              await produce.uploadWriteTagInfo({
                brandId,
                flavorId: this.currentFlavorId,
                operationType: 2,
                codeOrTag: this.tagCounter.join(",")
              });

              this.currentFlavorId = flavorId;
              this.tagCounter = [];
            } catch (e) {
              log(e);
            }
          }


          let resp = await produce.scanBrandQrcode({ tag: tagId });
          if (resp.code === 200) {
            this.tagCounter.push(tagId);
            this.currentTagId = tagId;
            this.showFlavorWriteResult = true;
          } else {
            this.dialogTipsMessage = resp.message
            this.showDialogTips = true
          }

        } catch (e) {
          this.dialogTipsMessage = e
          this.showDialogTips = true
        }

      } catch (e) {
        nfcReader.endReaderSession(false, e);
      }finally {

        if (this.showNfcPopup) {
          this.showNfcPopup = false;
          this.disabledNfcButton = false;
        }
      }
    },


    async onUpdateBrandList() {
      await this.loadData();
    },

    async onComplete(tips = true) {
      const brandId = this.$route.query.brandId;
      const flavorId = this.flavors[this.currenFlavorSelected].id;
      try {
        const tagIds = this.tagCounter.join(",");
        const resp = await produce.uploadWriteTagInfo({ brandId, flavorId, operationType: 2, codeOrTag: tagIds });

        if (resp.code === 200) {
          this.showFlavorWriteResult = true;
          this.$toast(resp.message);
        } else {
          this.dialogTipsMessage = resp.message
          this.showDialogTips = true

        }
        this.showFlavorWriteResult = false;
        this.$router.push("/customization/history");
      } catch (e) {
        this.dialogTipsMessage = e
        this.showDialogTips = true
      }
    }
  },
  computed: {
    disableEdit() {
      return this.currenProductSelected === -1 || this.currenFlavorSelected === -1;
    },
    selectedFlavor() {
      if (this.currenFlavorSelected !== -1) {
        return this.flavors[this.currenFlavorSelected];
      }
      return { labelList: [] };
    },
    createText() {
      if (this.tagCounter.length > 0 || this.qrcodeCounter.length > 0) {
        return "Continue";
      }
      return "Create";
    },
    cancelText() {
      if (this.tagCounter.length > 0 || this.qrcodeCounter.length > 0) {
        return "Completed";
      }
      return "Cancel";
    }
  },
  async mounted() {
    setTimeout(() => {
      bus.$emit("stepChange", 2);
    });
    console.log(`mounted product id = ${this.$route.params.productId}`);
    await this.loadData();
  }
};
</script>


<style scoped lang="less">
.flavor-wrap {
  & > * + * {
    margin-top: 12px;
  }
}

.flavor-item-wrap {
  & > * + * {
    margin-top: 8px;
  }
}

.content {
  height: 100%;
  padding-bottom: calc(70px + env(safe-area-inset-bottom) + 16px);
  overflow-y: auto;
  background: #f6f6f6;
}

</style>